import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

// Redux
import { setOrderDataAction } from '../../redux/Actions/CreateOrderActions';
import { getOrderSummary } from '../../redux/Reducers/CreateOrderReducer';

// Utils
import { amountCheckFn } from '../../utils/commonUtil';

// Components
import Loader from '../../components/Loader';

export default function EstimateSidebar() {
  const dispatch = useDispatch();
  const { selectedServices, orderPromoCode, final_tip, orderServiceAddress, orderIsRush, orderProvider } = useSelector(
    (s) => s.createNewOrder
  );
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState({});

  useEffect(() => {
    if (isEmpty(selectedServices)) {
      setSummary({});
      return;
    }
    setLoading(true);
    const payload = {
      items: selectedServices.map((s) => ({ service_id: s.service_id, quantity: s.quantity })),
      ...(orderPromoCode && { promo_code: orderPromoCode }),
      final_tip: final_tip === null ? undefined : final_tip,
      address_id: orderServiceAddress?.id,
      is_rush: orderIsRush?.is_rush,
      ...(orderProvider?.id && { worker_id: orderProvider.id }),
    };
    getOrderSummary(payload).then((res) => {
      setLoading(false);
      if (res?.status === 200 || res?.status === 201) {
        setSummary(res?.data || {});
        dispatch(setOrderDataAction({ orderSummaryError: null }));
      } else {
        dispatch(setOrderDataAction({ orderSummaryError: res?.message, orderPromoCode: null }));
      }
    });
  }, [selectedServices, orderPromoCode, final_tip, orderIsRush]);

  if (isEmpty(selectedServices)) return null;

  return (
    <div className='border-client-300/30 rounded-lg border bg-white p-4 shadow-sm'>
      {loading ? (
        <Loader text='Calculating...' classes='h-32' />
      ) : (
        <>
          {summary?.items?.length > 0 && (
            <table className='mb-3 w-full text-sm'>
              <thead>
                <tr className='border-b border-dashed border-slate-200 text-xs text-slate-400'>
                  <th className='py-1 text-left'>Service</th>
                  <th className='py-1 text-right'>Qty</th>
                  <th className='py-1 text-right'>Price</th>
                </tr>
              </thead>
              <tbody>
                {summary.items.map((s, i) => (
                  <tr key={i} className='border-b border-slate-100'>
                    <td className='py-1.5'>{s.name}</td>
                    <td className='py-1.5 text-right'>{s.quantity}</td>
                    <td className='py-1.5 text-right'>{amountCheckFn(s.client_fee)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <div className='space-y-1 text-sm'>
            <div className='flex justify-between'>
              <span className='text-slate-500'>Subtotal</span>
              <span>{amountCheckFn(summary?.subtotal)}</span>
            </div>
            {summary?.promo_code_discount > 0 && (
              <div className='flex justify-between'>
                <span className='text-slate-500'>Promo</span>
                <span className='text-green-600'>-{amountCheckFn(summary.promo_code_discount)}</span>
              </div>
            )}
            {summary?.priority_fee > 0 && (
              <div className='flex justify-between'>
                <span className='text-slate-500'>Priority</span>
                <span>+{amountCheckFn(summary.priority_fee)}</span>
              </div>
            )}
            {summary?.tip > 0 && (
              <div className='flex justify-between'>
                <span className='text-slate-500'>Tip</span>
                <span>{amountCheckFn(summary.tip)}</span>
              </div>
            )}
            <div className='flex justify-between'>
              <span className='text-slate-500'>Service Fee</span>
              <span>{amountCheckFn(summary?.service_fee)}</span>
            </div>
            <hr className='border-slate-200' />
            <div className='flex justify-between font-semibold'>
              <span>Estimated Total</span>
              <span>{amountCheckFn(summary?.estimated_total_cost)}</span>
            </div>
          </div>
          {summary?.order_minimum > 0 && (
            <p className='mt-2 text-xs text-blue-400'>${summary.order_minimum} minimum charge applies.</p>
          )}
        </>
      )}
    </div>
  );
}
